export default {
  metrics: {
    nrr: {
      title: 'NRR % (kvartalsvis)',
      description:
        '(Abonnementsindtægt {{currentMonth}} (Q{{currentQuarter}}) + indtægt fra servicegebyrer {{currentMonth}} (Q{{currentQuarter}})) / (Abonnementsindtægt {{prevMonth}} (slutningen af Q{{prevQuarter}}) + indtægt fra servicegebyrer {{prevMonth}} (slutningen af Q{{prevQuarter}})) * 100',
    },
    upgrades: 'Kontoopgraderinger',
    downgrades: 'Kontonedgraderinger',
    gte_c_tier: 'Konti ≥ C-niveau',
    churn: 'Frafald (suspenderet)',
    offers_turned_on: 'Aktive tilbud',
    flyers_sent: 'Sendte flyers',
    on_google_ads_trial: 'I Google Ads-prøveperiode',
    converted_google_ads: 'Succesfuldt konverteret Google Ads',
    first_time_500_monthly_sales: 'Første måned med 500 €',
    '14_days_no_sales': '14 dage live, ingen omsætning',
  },
  details: {
    address: 'Adresse',
    subscriptions: 'Nuværende abonnementer',
    best_sales: 'Bedste måned nogensinde',
    sales: 'Salg {{month}}',
    tier: 'Niveau {{month}}',
    live_from: 'Go-live-dato',
    owner_phone: 'Ejerens telefon',
    owner_email: 'Ejerens e-mail',
    owner: 'Ejerens navn',
    name: 'Restaurant',
    export_csv: 'Eksportér CSV',
  },
  publish: 'Udgiv',
  unpublish: 'Fjern udgivelse',
};
